import { render, staticRenderFns } from "./Users.vue?vue&type=template&id=2f8836e7&scoped=true&"
import script from "./Users.vue?vue&type=script&lang=js&"
export * from "./Users.vue?vue&type=script&lang=js&"
import style0 from "./Users.vue?vue&type=style&index=0&id=2f8836e7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8836e7",
  null
  
)

component.options.__file = "Users.vue"
export default component.exports